<template>
  <div class="top" v-show="visible">
    <div class="top-icon" type="vertical-align-top" @click="toTop"
         :style="{bottom:screenHeight + scrollTop +'px'}"></div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    data () {
      return {
        visible: false,
        screenHeight: 0,
        scrollTop: 0,
      }
    },
    mounted () {
      // 监听（绑定）滚轮滚动事件
      window.addEventListener('scroll', this.handleScroll, false)
    },
    methods: {
      toTop () {
        document.documentElement.scrollTop = document.body.scrollTop = 0
      },
      handleScroll () {
        // 设备/屏幕高度
        this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight
        // 设备/屏幕高度 滚动距离
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        // 滚动条的总高度
        // let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        //滚动条到底部的条件
        // if (scrollTop + this.screenHeight === scrollHeight) {
        //   // div 到头部的距离 + 屏幕高度 = 可滚动的总高度
        //   console.log('到底部')
        // }
        this.visible = this.scrollTop !== 0
      },
    },
  }
</script>

<style scoped>
  .top {
    cursor: pointer;
    position: fixed;
    bottom: 8px;
    right: 20px;

    background-color: rgba(0, 0, 0, .45);

    border-radius: 50%;
    padding: 8px;
    transition: all .3s cubic-bezier(.645, .045, .355, 1)
  }

  .top:hover {
    background-color: rgba(0, 0, 0, .6);
  }

  .top-icon {
    font-size: 25px;
    width: 16px;
    height: 16px;
    color: white;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAABGdBTUEAALGPC/xhBQAAAbtJREFUWAntmMtKw0AUhhMvS5cuxILgQlRUpIggIoKIIoigG1eC+AA+jo+i6FIXBfeuXIgoeKVeitVWJX5HWhhDksnUpp3FDPyZk3Nm5nycmZKkXhAEOXSA3lG7muTeRzmfy6HneUvIhnYkQK+Q9NhAA0Opg0vBEhjBKHiyb8iGMyQMOYuK41BcBSypAL+MYXSKjtFAW7EAGEO3qN4uMQbbAkXiSfRQJ1H6a+yhlkKRcAoVFYiweYNjtCVQJJpBz2GCiPt7fBOZQpFgDpUikse5HgnkM4Fi4QX0Fpc5wf9EbLqpUCy4jMoJSXWhFwbMNgWKhVbRhy5jirhs9fy/oFhgHVVTJEs7RLZ8sSEoJm6iz7SZDMbJ+/OKERQTttCXQRLToRUmrKWCYuA2+jbN0MB4OQobYShfdTCgn/sL1K36M7TLrN3n+758aPy2rrpR6+/od5E8tf/A1uLS9aId5T7J3CNYihkQ4D9PiMdMC7mp4rjB9kjFjZp8BlnVHJBuO1yFXIV0FdDF3RlyFdJVQBdv5AxVdIsq8apiZ2PyYO1EVykesGfZEESsCkweyR8MUW+V8uJ1gkYipmpdP1pm2aJVPEGzAAAAAElFTkSuQmCC) 100%/100% no-repeat;
  }
</style>